import Vue from "vue";
import VueTagManager from "vue-tag-manager";

// Do this before creating the Vue app
Vue.use(VueTagManager, {
  gtmId: "GTM-TQ4NHCZ"
});
